import React from 'react';
import { NavLink } from 'react-router-dom';

const WhatWeOffer = () =>{
    return (
      <>
      <div className="cadServices cadAbout">
            <h2>WHAT WE OFFER?</h2>
            <div className='container'>
                  <div className='cadServicesInner row'>
                        <div className='cadServicesInnerCol col-12'>
                              <div className='cadServicesInnerAlign row'>
                                    <div className='cadServicesImgsec col-6'>
                                          <div className='cadServicesImgSecInner'>
                                          <NavLink to="/realistic-rendering">
                                                <img 
                                                src="/gallery/realistic-image.jpg"
                                                alt="realistic-service" />
                                          </NavLink>
                                          </div>
                                    </div>
                                    <div className='cadServicesContent col-6'>
                                          <h5>REALISTIC IMAGES</h5>
                                          <p>Showcase your jewelry to the whole world with Rendered Photorealistic Still Images. Customize through the endless possibilities of How you want your Jewelry to look.</p>
                                          <div className="cadAboutBtn">
                                                <NavLink to="/realistic-rendering">READ MORE</NavLink>
                                          </div>
                                    </div>
                              </div>
                        </div>
                        <div className='cadServicesInnerCol col-12'>
                              <div className='cadServicesInnerAlign cadServicesRevers row'>
                                    <div className='cadServicesContent col-6'>
                                          <h5><span>3</span>D ANIMATIONS</h5>
                                          <p>Get yourself a Professional Video of your product which enhances the beauty of your item and allows the viewer to explore all the crucial angles of your masterpiece.</p>
                                          <div className="cadAboutBtn">
                                                <NavLink to="/animation-video">READ MORE</NavLink>
                                          </div>
                                    </div>
                                    <div className='cadServicesImgsec col-6'>
                                          <div className='cadServicesImgSecInner ImgInnerRight'>
                                                <NavLink to="/animation-video">
                                                      <video className='videoTag' autoPlay loop muted>
                                                            <source src="/gallery/3D-animation-video.mp4" type='video/mp4' />
                                                      </video>
                                                </NavLink>
                                          </div>
                                    </div>
                              </div>
                        </div>
                        <div className='cadServicesInnerCol col-12'>
                              <div className='cadServicesInnerAlign row'>
                                    <div className='cadServicesImgsec col-6'>
                                          <div className='cadServicesImgSecInner'>
                                          <NavLink to="/cad-modeling">
                                                <img 
                                                src="/gallery/3D-cad-modeling.jpg"
                                                alt="3D-cad-modeling" />
                                          </NavLink>
                                          </div>
                                    </div>
                                    <div className='cadServicesContent col-6'>
                                          <h5><span>3</span>D CAD MODELING</h5>
                                          <p>Turn your ideas into reality with the help of our expert CAD Artists who can design your jewelry just the way you want, be it traditional jewelry, artistic modern designs or 3D organic face and animal figures.</p>
                                          <div className="cadAboutBtn">
                                                <NavLink to="/cad-modeling">READ MORE</NavLink>
                                          </div>
                                    </div>
                              </div>
                        </div>
                        <div className='cadServicesInnerCol col-12'>
                              <div className='cadServicesInnerAlign cadServicesRevers row'>
                                    <div className='cadServicesContent col-6'>
                                          <h5>CAD EDITING</h5>
                                          <p>Have the CAD Models already and want to make some changes or create something new out of it? We also hold the expertise in editing your previously made models, doesn’t matter if the models are made by us or someone else, as long as the models are in editable condition, we can do it very happily.</p>
                                          <div className="cadAboutBtn">
                                                <NavLink to="/retouching-and-editing">READ MORE</NavLink>
                                          </div>
                                    </div>
                                    <div className='cadServicesImgsec col-6'>
                                          <div className='cadServicesImgSecInner ImgInnerRight'>
                                          <NavLink to="/retouching-and-editing">
                                                <img 
                                                src="/gallery/cad-editing.jpg"
                                                alt="CAD-editing" />
                                          </NavLink>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>
      </div>
        </>
    );
}

export default WhatWeOffer;